<script>
    import Navbar from "../widget/Navbar.svelte";
    import Footer from "../widget/Footer.svelte";
</script>
<Navbar/>

<div class="container">
	<h1>Unicenta Web App</h1>
	<div class="col-12 col-md-12 p-3">
        <div class="ratio ratio-16x9">
            <iframe src="https://www.youtube.com/embed/aEVYUeubfJk" title="Unicenta website application" class="rounded" allowfullscreen></iframe>
          </div>
          <p>This time for build your modern website and integration with unicentapos desktop apps.</p>
        </div>	
</div>
<Footer/>